interface TaskData {
    id: string;
    title: string;
    status: string;
    priority: string;
    task_type: string;
    assigned_to?: string;
    created_at?: string;
    updated_at?: string;
    project_id?: string;
    due_date?:string
  }
  
  export const worflowCategory=["todo", "requirements_signoff","dev_inprogress", "dev_completed","qa_inprogress","qa_completed","uat_inprogress", "in_progress", "uat_done"]
  export function getTasksDueWithin7Days(tasks: TaskData[]): any[] {
    try {
        if (!Array.isArray(tasks) || tasks.length === 0) {
            return [];
          }
        
          const now = Date.now();
          const sevenDaysMs = 7 * 24 * 60 * 60 * 1000;
        
          return tasks.filter((task) => {
            try {
              if (!task || !task.due_date) {
                return false;
              }

              if(!task.status){
                throw new Error("No task status available")
              }
        
              const dueTime = new Date(task.due_date).getTime();
        
              if (isNaN(dueTime)) {
                return false;
              }
        
              const diff = dueTime - now;
              return (diff >= 0 && diff <= sevenDaysMs)&&(worflowCategory.includes(task.status));
            } catch (error) {
              throw error
            }
          });
    } catch (error) {
        throw error
    }
   
  }